import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAppSelector, useAppDispatch } from "../../_app";
import { EmployeeService } from "../../_service";
import { Notify, Utils, calculateSDL, calculateCPFValues } from "../../utils";
import { H3Heading, Heading } from "../appSettings/AppSettingsStyles";
import {
  CommonModal,
  CustomButton,
  CustomDateField,
  CustomNumberField,
  CustomSelectField,
  CustomTextField,
  Loader,
  NavigateBack,
} from "../../components";
import { LoaderContainer } from "../../CommonStyles";
import { DisplayFlex, RecordSeletedText } from "../payslip/PayslipStyles";
import { TableFilterHeader, TablePaginationHeader } from "./component";
import { TableHeader } from "../../components/table";
import { TableRow } from "@mui/material";
import { IRASTable, IRASTableCol } from "../filing/CPFFilingStyles";
import { PulsingIcon, TableColumn } from "../users/styles";
import { Constant } from "../../config";
import CustomTooltip from "../../components/CustomTooltip";
import AnnualIncrementRow from "./AnnualIncrementRow";
import cloneDeep from "lodash.clonedeep";
import AnnualBonusRow from "./AnnualBonusRow";
import moment from "moment";
import DatePicker from "../../components/customFormField/CommonDatePicker";
import WarningModal from "./component/WarningModal";



const InfoTextContainer = () => {
  return (
    <div style={{
      padding: "1.5rem",
      // border: "1px solid #e0e0e0",
      borderRadius: "0.75rem",
      // margin: '1rem 0',
      marginLeft: 'auto',
      marginRight: "1.75rem",
      backgroundColor: "#f8f9fa",
      boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
      width: "100%",
      border: '1px solid #333',
    }}>
      <h3 style={{
        marginBottom: "1rem",
        color: "#2c3e50",
        fontSize: "1.1rem",
        fontWeight: 600
      }}>Steps to process Annual Bonus Exercise</h3>

      <ol style={{
        listStyle: "decimal",
        paddingLeft: "20px",
        fontFamily: "system-ui, -apple-system, sans-serif",
        lineHeight: "1.8",
        color: "#4a5568",
        fontSize: "0.95rem",
        margin: 0
      }}>
        <li>
          Wait for TellBoss's request to prepare the annual bonus exercise on the Number ( usually 1 month )
          of the month given by the Boss
        </li>
        <li>
          Admin prepares the result - by click To Calculate Annual Bonus

        </li>
        <li>When ready, admin clicks here to send the result to the TellBoss app</li>
        <li>Boss reviews and makes changes, then sends revised figures to Admin</li>
        <li>Admin changes the amounts accordingly and sends them to TellBoss for final approval</li>
        <li>Admin receives final approval from Boss via the TellBoss app</li>
        <li>Admin changes the annual bounus amounts accordingly, click the create annual Bonus for every employee, and sends to the employees and send to the employee payslips. on the month Bonus is to be paid.</li>
      </ol>
    </div>
  )
}


const AnnualBonus = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const date = new Date();

  const location = useLocation();
  const locationData = location.state;
  const isEdit = locationData?.isEdit;
  const isFinalized = locationData?.isFinalized;

  const user = useAppSelector((state) => state.user);
  const companyId = useAppSelector((state) => state.user.defaultCompnayId);
  const currentPayrunDate = useAppSelector(
    (state) => state.user.current_payrun_date
  );
  const [year, setYear] = useState<string>(
    currentPayrunDate?.split("-")[0] || date.getFullYear()
  );
  const [month, setMonth] = useState<string>(
    `${parseInt(currentPayrunDate?.split("-")[1] || 0) || date.getMonth() + 1}`
  );
  const [status, setStatus] = useState("");
  console.log("status", status);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [openWarn, setOpenWarn] = useState<boolean>(false);
  const [openSecond, setOpenSecond] = useState<boolean>(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [openUnapprove, setOpenUnapprove] = useState(false);
  const [openExecute, setOpenExecute] = useState(false);

  console.log("month", month, date.getMonth(), parseInt(currentPayrunDate?.split("-")[1] || 0) + 1);

  const [commonBonusFactor, setCommonBonusFactor] =
    useState<any>('1.00');
  const [employeeData, setEmployeeData] = useState<any[]>([]);
  const [filteredEmployeeData, setFilteredEmployeeData] = useState<any[]>([]);
  const [workedFrom, setWorkedFrom] = useState<any>(
    `${date.getFullYear() - 1}-01-01`
  );
  const [workedTill, setWorkedTill] = useState<any>(
    `${date.getFullYear() - 1}-12-31`
  );
  // the default effective date is the companies current payrun date
  const [effectiveDate, setEffectiveDate] = useState(moment(currentPayrunDate).format("YYYY-MM-DD"));
  const shouldNotify = !['sent_for_approval', 'finalized', 'executed'].includes(status);
  console.log("shouldNotify",shouldNotify);
  const [duplicateYearModal, setDuplicateYearModal] = useState(false)
  const [duplicateYearWarningMessage, setDuplicateYearWarningMessage] = useState("")
  const [duplicateYearWarningTitle, setDuplicateYearWarningTitle] = useState("")
  useEffect(() => {      
    const isPastDate = moment(effectiveDate).isBefore(moment(currentPayrunDate).format("YYYY-MM-DD"));
    if (isPastDate && shouldNotify) {
      Notify("Please choose an Payrun Date that is equal to or greater than the current Payrun Date.", 0);
    }
  }, [effectiveDate, status]);
  // const monthsOptions = parseInt(year) > parseInt(currentPayrunDate?.split('-')[0]) ? Utils.MONTH_OPTIONS : Utils.MONTH_OPTIONS?.slice(parseInt(currentPayrunDate?.split('-')[1]));
  // const yearOptions = Utils.getDefaultYearRange();
  const yearOptions = getYearRange(currentPayrunDate?.split('-')[0]);
  const monthsOptions = Utils.MONTH_OPTIONS;

  const [pageInfo, setPageInfo] = useState<{
    pageNumber: number;
    totalLength: number;
    pagePerData: number;
  }>({
    pageNumber: 1,
    totalLength: employeeData?.length || 10,
    pagePerData: 10,
  });

  const [totalValues, setTotalValues] = useState<any>({
    totalSalary: 0,
    totalBonusAmount: 0,
    averageBonusMonth: 0,
    totalCpfEmployee: 0,
    totalCpfEmployer: 0,
    totalCpfTotal: 0,
    totalSdl: 0,
  });

  const getEmployeeBonus = async () => {
    const defaultCompanyId = user.defaultCompnayId;

    if (defaultCompanyId) {
      setIsLoading(() => true);
      try {
        const res = await EmployeeService._getInitialEmployeeAnnualBonusData(
          defaultCompanyId,
          workedFrom,
          workedTill
        );
        if (res.status === 200) {
          let data = res?.data?.data;
          setEmployeeData(data);
        }
      } catch (e: any) {
        console.log("err", e);
        Utils.showErrorMessage(e);
      }
      setIsLoading(() => false);
    }
  };

  const getEmployeeBonusEditData = async () => {
    const defaultCompanyId = user.defaultCompnayId;

    if (defaultCompanyId) {
      setIsLoading(() => true);
      try {
        const res = await EmployeeService._getEmployeeAnnualBonusEditData(locationData?.id);

        if (res.status === 200) {
          let data = res?.data?.data;
          setEmployeeData(data?.bonus_records);
          setYear(data?.bonus?.year)
          setMonth(data?.bonus?.month_to_be_paid)
          setEffectiveDate(data?.bonus?.effective_date)
          // setWorkedFrom(data?.bonus?.period_from)
          setWorkedTill(data?.bonus?.period_to)
          setCommonBonusFactor(data?.bonus?.global_avg_bonus)
          setTotalValues({
            totalSalary: data?.bonus?.total_salary,
            totalBonusAmount: data?.bonus?.total_bonus_amount,
            averageBonusMonth: data?.bonus?.avg_bonus_month,
            totalCpfEmployee: data?.bonus?.total_cpf_employee ?? 0,
            totalCpfEmployer: data?.bonus?.total_cpf_employer ?? 0,
            totalCpfTotal: data?.bonus?.total_cpf_total ?? 0,
            totalSdl: data?.bonus?.total_sdl ?? 0,
          });
          setStatus(data?.bonus?.status)
        }
      } catch (e: any) {
        console.log("err", e);
        Utils.showErrorMessage(e);
      }
      setIsLoading(() => false);
    }
  };

  const calculateBonusAmount = (
    joiningDate: string,
    salary: string,
    name: string,
  ) => {
    let joiningDateObj = moment(joiningDate);
    let comparisonDateObj = moment(`${year}-01-01`);
    let diff = comparisonDateObj.diff(joiningDateObj, "days");

    // let daysWorked = moment(`${year}-12-31`).diff(joiningDateObj, "days");
    let daysWorked = moment(`${workedTill}`).diff(joiningDateObj, "days") + 1; // added one to inclue the joining date

    let status = daysWorked < 365 ? "partialYear" : "FullYear";

    let basicSalary = parseFloat(`${salary}`?.replace(/,/g, ""));

    let bonusAmount = 0;

    if (daysWorked < 365) {
      bonusAmount = Math.ceil((daysWorked / 365) * basicSalary * (commonBonusFactor));
    } else {
      bonusAmount = basicSalary * (commonBonusFactor);
    }

    if (joiningDateObj.isAfter(moment(workedTill, "YYYY-MM-DD"))) {
      bonusAmount = 0
    }


    return bonusAmount;
  };

  const calculateBonusMonths = (
    bonusAmount: string | number,
    salary: string
  ) => {
    let amount = parseFloat(`${bonusAmount}`);
    let basicSalary = parseFloat(`${salary}`?.replace(/,/g, "")) || 0.0;
    let bonusMonth = Number((amount / basicSalary).toFixed(2)) || 0.0;

    return bonusMonth;
  };

  useEffect(() => {
    if (isEdit || isFinalized) {
      getEmployeeBonusEditData();
    } else {
      getEmployeeBonus();
    }

  }, [workedFrom, workedTill]);

  // useEffect(()=> {
  //   setMonth(monthsOptions[0].value)
  // }, [year])


  const updateTotal = (data: any) => {
    let totalObj: any = {
      totalSalary: 0,
      totalBonusAmount: 0,
      averageBonusMonth: 0,
      totalCpfEmployee: 0,
      totalCpfEmployer: 0,
      totalCpfTotal: 0,
      totalSdl: 0,
    };

    data.forEach((item: any) => {
      if (item.archived === true) return;
      totalObj.totalSalary =
        totalObj.totalSalary +
        (parseFloat(`${item?.basic_salary}`?.replace(/,/g, "")) || 0);
      totalObj.totalBonusAmount =
        totalObj.totalBonusAmount + parseFloat(item?.bonus_amount);
      totalObj.totalCpfEmployee += parseFloat(item?.cpf_employee) || 0;
      totalObj.totalCpfEmployer += parseFloat(item?.cpf_employer) || 0;
      totalObj.totalCpfTotal += parseFloat(item?.cpf_total) || 0;
      totalObj.totalSdl += parseFloat(item?.sdl) || 0;
    });

    totalObj.averageBonusMonth = (
      ((totalObj?.totalBonusAmount / totalObj?.totalSalary)) || 0
    ).toFixed(2);

    totalObj.totalSalary = parseFloat(totalObj.totalSalary);
    totalObj.totalBonusAmount = parseFloat(totalObj.totalBonusAmount);
    totalObj.averageBonusMonth = parseFloat(totalObj.averageBonusMonth);

    setTotalValues(totalObj);

  };

  const handleCommonBonusFactorChange = async () => {
    try {
      let data = cloneDeep(employeeData);

      let activeEmployeeIds = data?.filter((item: any) => !item.archived)?.map((item: any) => item.employee)
      
      if (!isEdit) {
        await EmployeeService._validateBonusYear(
          companyId, workedTill, effectiveDate, activeEmployeeIds
        )
      }
  
      if (parseFloat(commonBonusFactor) < 0) {
        Notify("Average bonus month cannot be negative!", 0, { autoClose: false });
        return null;
      }
  
      data.forEach((item: any) => {
        item.bonusAmount = calculateBonusAmount(item?.date_joined, item?.basic_salary, item?.employee_name)
        item.bonus_amount = item?.bonusAmount;

        item.numberOfBonusMonths = calculateBonusMonths(item?.bonus_amount, item?.basic_salary)
        item.no_of_bonus_months = item.numberOfBonusMonths;

        const ow = parseFloat(`${item?.basic_salary}`?.replace(/,/g, "")) || 0;
        const aw = item.bonus_amount || 0;
        item.sdl = calculateSDL(ow, aw, item?.sdl_data || []);
        const cpf = calculateCPFValues(ow, aw, item?.cpf_calculator_data || []);
        item.cpf_employee = cpf.cpfEmployee;
        item.cpf_employer = cpf.cpfEmployer;
        item.cpf_total = cpf.cpfTotal;
      });
  
      setEmployeeData(data);
      updateTotal(data);
    } catch (e) {
      setDuplicateYearWarningMessage(e.response.data.message)
      setDuplicateYearWarningTitle(e.response.data.error)
      setDuplicateYearModal(true)
      setWorkedTill("")
      setEffectiveDate("")
    }
  };

  const handlePageValueChange = (
    type: "next" | "previous" | "first" | "last"
  ) => {
    if (type === "next") {
      const isLast =
        pageInfo.pageNumber * pageInfo.pagePerData < employeeData.length;
      if (isLast) {
        setPageInfo((prev) => ({
          ...prev,
          pageNumber: prev.pageNumber + 1,
        }));
      }
    }
    if (type === "previous") {
      if (pageInfo.pageNumber > 1) {
        setPageInfo((prev) => ({
          ...prev,
          pageNumber: prev.pageNumber - 1,
        }));
      }
    }
    if (type === "first") {
      setPageInfo((prev) => ({
        ...prev,
        pageNumber: 1,
      }));
    }
    if (type === "last") {
      setPageInfo((prev) => ({
        ...prev,
        pageNumber: Math.ceil(pageInfo.totalLength / pageInfo.pagePerData),
      }));
    }
  };

  const handleSave = async (isDraft: boolean, goBack: boolean = false) => {
    setOpen(false);

    let payload: any = {
      bonus_data: {},
      bonus_records: [],
    }

    let data = cloneDeep(employeeData);

    payload.bonus_records = data?.map((emp: any) => {
      let newEmp: any = {};
      Object.keys(emp).forEach((key: any) => {
        if (key === "bonusAmount") {
          newEmp.bonus_amount = emp[key];
        } else if (key === "numberOfBonusMonths") {
          newEmp.no_of_bonus_months = emp[key];
        } else if (key === "basic_salary") {
          newEmp[key] = `${emp[key]}`?.replace(/,/g, "");
        } else {
          newEmp[key] = emp[key];
        }
      });
      newEmp.sdl = emp.sdl ?? 0;
      newEmp.cpf_employee = emp.cpf_employee ?? 0;
      newEmp.cpf_employer = emp.cpf_employer ?? 0;
      newEmp.cpf_total = emp.cpf_total ?? 0;
      return newEmp;
    });

    if (moment(effectiveDate).isBefore(moment(currentPayrunDate).format("YYYY-MM-DD"))) {
      Notify("Please choose an Payrun Date that is equal to or greater than the current Payrun Date.", 0)
      return;
    }

    payload.bonus_data = {
      "company": companyId,
      // "year": year,
      // "month_to_be_paid": month,
      // "period_from": workedFrom,
      "effective_date": effectiveDate,
      "period_to": workedTill,
      "global_avg_bonus": commonBonusFactor,
      "status": isDraft ? "preview" : "sent_for_approval",
      "total_salary": totalValues?.totalSalary,
      "total_bonus_amount": totalValues?.totalBonusAmount,
      "avg_bonus_month": totalValues?.averageBonusMonth,
      "total_cpf_employee": payload.bonus_records.reduce((sum: number, r: any) => sum + (parseFloat(r.cpf_employee) || 0), 0),
      "total_cpf_employer": payload.bonus_records.reduce((sum: number, r: any) => sum + (parseFloat(r.cpf_employer) || 0), 0),
      "total_cpf_total": payload.bonus_records.reduce((sum: number, r: any) => sum + (parseFloat(r.cpf_total) || 0), 0),
      "total_sdl": payload.bonus_records.reduce((sum: number, r: any) => sum + (parseFloat(r.sdl) || 0), 0),
    }

    if (isEdit) {
      payload.bonus_data.id = locationData?.id
    }


    try {
      const { status } = isEdit ? await EmployeeService._updateAnnualBonus(payload) : await EmployeeService._saveAnnualBonus(payload);

      if (status >= 200 && status < 300) {
        Notify(isEdit ? "Annual Bonus Updated" : "Annual Bonus Saved", 1);

        if (goBack) {
          navigate(-1);
        }
      }
    } catch (error: any) {
      console.log("inside Error", error)

      Utils.showErrorMessage(error);
      // Notify(error?.response?.data?.error?.message || "Something went wrong!", 0);

    }
  };

  const handleApprove = async (id: any, action: String) => {
    try {
      const { status, data } = await EmployeeService._sendForTellbossApprovalBonus(id, action);
      if (status === 200) {
        Notify(data.message, 1)
        setOpenConfirm(false)
        navigate(-1)
      }

    } catch (error) {
      Notify("Something went wrong", 0)
    }

  }
  const handleExecute = async (id: any) => {

    try {
      const { status, data } = await EmployeeService._sendForExcuteBonus(id);
      if (status === 200) {
        Notify(data.message, 1)
        setOpenConfirm(false)
        navigate(-1)
      }

    } catch (error) {
      Notify("Something went wrong", 0)
    }

  }



  // Only when updating from row and isEdit=true
  const handleSaveRow = async (empData: any) => {
    let totalObj: any = {
      totalSalary: 0,
      totalBonusAmount: 0,
      averageBonusMonth: 0
    };

    empData.forEach((item: any) => {
      totalObj.totalSalary =
        totalObj.totalSalary +
        (parseFloat(`${item?.basic_salary}`?.replace(/,/g, "")) || 0);
      totalObj.totalBonusAmount =
        totalObj.totalBonusAmount + parseFloat(item?.bonus_amount);
    });

    totalObj.averageBonusMonth = (
      ((totalObj?.totalBonusAmount / totalObj?.totalSalary)) || 0
    ).toFixed(2);

    totalObj.totalSalary = parseFloat(totalObj.totalSalary);
    totalObj.totalBonusAmount = parseFloat(totalObj.totalBonusAmount);
    totalObj.averageBonusMonth = parseFloat(totalObj.averageBonusMonth);

    // -----------

    let payload: any = {
      bonus_data: {},
      bonus_records: [],
    }

    payload.bonus_records = empData?.map((emp: any) => {
      let newEmp: any = {};
      Object.keys(emp).forEach((key: any) => {
        if (key === "bonusAmount") {
          newEmp.bonus_amount = emp[key];
        } else if (key === "numberOfBonusMonths") {
          newEmp.no_of_bonus_months = emp[key];
        } else if (key === "basic_salary") {
          newEmp[key] = `${emp[key]}`?.replace(/,/g, "");
        } else {
          newEmp[key] = emp[key];
        }
      });
      newEmp.sdl = emp.sdl ?? 0;
      newEmp.cpf_employee = emp.cpf_employee ?? 0;
      newEmp.cpf_employer = emp.cpf_employer ?? 0;
      newEmp.cpf_total = emp.cpf_total ?? 0;
      return newEmp;
    });

    payload.bonus_data = {
      "company": companyId,
      "year": year,
      "month_to_be_paid": month,
      // "period_from": workedFrom,
      "period_to": workedTill,
      "global_avg_bonus": commonBonusFactor,
      "status": "preview",
      "total_salary": totalObj?.totalSalary,
      "total_bonus_amount": totalObj?.totalBonusAmount,
      "avg_bonus_month": totalObj?.averageBonusMonth,
      "total_cpf_employee": payload.bonus_records.reduce((sum: number, r: any) => sum + (parseFloat(r.cpf_employee) || 0), 0),
      "total_cpf_employer": payload.bonus_records.reduce((sum: number, r: any) => sum + (parseFloat(r.cpf_employer) || 0), 0),
      "total_cpf_total": payload.bonus_records.reduce((sum: number, r: any) => sum + (parseFloat(r.cpf_total) || 0), 0),
      "total_sdl": payload.bonus_records.reduce((sum: number, r: any) => sum + (parseFloat(r.sdl) || 0), 0),
    }

    if (isEdit) {
      payload.bonus_data.id = locationData?.id
    }


    try {
      const { status } = await EmployeeService._updateAnnualBonus(payload);
      if (status >= 200 && status < 300) {
        Notify("Annual Bonus Updated", 1);
      }
    } catch (error: any) {
      console.log("inside Error", error)

      Utils.showErrorMessage(error);
      // Notify(error?.response?.data?.error?.message || "Something went wrong", 0);

    }

  }

  const handleRowUpdate = (empId: any, amount: any, bonusMonthCount: any, sdl: number, cpfEmployee: number, cpfEmployer: number, cpfTotal: number) => {
    let index = employeeData?.findIndex((user) => user.employee === empId);
    let data = cloneDeep(employeeData)

    if (index >= 0) {
      data[index].bonusAmount = parseFloat(amount);
      data[index].bonus_amount = parseFloat(amount);

      data[index].numberOfBonusMonths = parseFloat(bonusMonthCount);
      data[index].no_of_bonus_months = parseFloat(bonusMonthCount);

      data[index].sdl = sdl;
      data[index].cpf_employee = cpfEmployee;
      data[index].cpf_employer = cpfEmployer;
      data[index].cpf_total = cpfTotal;

      setEmployeeData(data);
      updateTotal(data);
    }

    if (isEdit) {
      handleSaveRow(data);
    }

  }
  
  const handleDelete = (empId: any) => {
    console.log("-------------DELETE-----------------", empId)
    let index = employeeData?.findIndex((user) => user.employee === empId);
    let data = cloneDeep(employeeData)

    if (index >= 0) {
      data[index].archived = true;
      setEmployeeData(data);
      updateTotal(data);
    }
    console.log(data)
  }

  // page change
  useEffect(() => {
    const startIndex =
      pageInfo.pageNumber * pageInfo.pagePerData - pageInfo.pagePerData;
    const endIndex =
      pageInfo.pageNumber * pageInfo.pagePerData > employeeData.length
        ? employeeData.length
        : pageInfo.pageNumber * pageInfo.pagePerData;

    setPageInfo((prev) => ({
      ...prev,
      totalLength: employeeData?.length,
    }));


    setFilteredEmployeeData(() => employeeData.slice(startIndex, endIndex));
  }, [pageInfo.pageNumber, employeeData]);


  {
    // console.log("theData", employeeData, locationData, isEdit, totalValues);

  }

  return (
    <div style={{
      // pointerEvents: isFinalized ? 'none' : 'auto'
    }}>
      <div style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
      }}>
        <NavigateBack />
        <Heading>{"Annual Bonus"}</Heading>
        <H3Heading> - {user.defaultCompany}</H3Heading>
        <CustomTooltip title={<InfoTextContainer />} placement={'right'}>
          <PulsingIcon>
            <img src="/info-outline.svg" style={{ width: '25px', height: '25px' }} />
          </PulsingIcon>
        </CustomTooltip>
      </div>
      <div style={{
        display: "flex",
        width: "100%",
      }}>

        <div
          style={{
            paddingLeft: "1.5rem",
            paddingBottom: "1rem",
            paddingTop: "1rem",
            borderRadius: "0.75rem",
            marginLeft: "auto",
            marginRight: "1.75rem",
            backgroundColor: "#f8f9fa",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
            border: "1px solid #333",
            width: "50%"
          }}
        >
          <div style={{ width: "50%" }}>
            {/* Date Selection */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "1rem",
              }}
            >
              <span
                style={{
                  margin: ".5rem 0",
                  marginTop: "1rem",
                  color: "rgb(71, 101, 117)",
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                }}
              >
                {`2. Bonus For Employees Who Worked till`}
              </span>
              <CustomDateField
                date={workedTill}
                setDate={setWorkedTill}
                startYear={new Date().getFullYear() - 3}
                endYear={new Date().getFullYear() + 6}
                openAsModal={false}
                disabled={isEdit || isFinalized}
                require
              />
            </div>

            {/* Payrun Date */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "1rem",
                width: "fit-content",
              }}
            >
              <span
                style={{
                  margin: ".5rem 0",
                  marginTop: "1.2rem",
                  color: "rgb(71, 101, 117)",
                  fontWeight: 700,
                  whiteSpace: "nowrap",
                }}
              >
                {"3. Add to Payroll Month"}
              </span>
              <CustomDateField
                date={effectiveDate}
                setDate={setEffectiveDate}
                disabled={status === "finalized" || status === "sent_for_approval" || status === "executed"}
                require
              />


            </div>
            {!['sent_for_approval', 'finalized', 'executed'].includes(status) && <span style={{
              color: '#D32F2F',
              fontSize: '14px',
              marginTop: '4px',
              whiteSpace: "nowrap"
            }}>
              {moment(effectiveDate).isBefore(moment(currentPayrunDate).format("YYYY-MM-DD")) && (
                <>
                  <span style={{ fontSize: '15px' }}></span>
                  <span>⚠️ Please choose the latest unfinalised Pay Month or a future Pay Month after {moment(currentPayrunDate).format("DD-MM-YYYY")}.</span>
                </>
              )}
            </span>
            }

            {/* Annual Bonus Year Selection */}
            {/* <div
              style={{
                display: "flex",
                gap: "20px",
                width: "70%",
                alignItems: "center",
                marginTop: ".8rem",
              }}
            >
              <p style={{ color: "#333", whiteSpace: "nowrap" }}>2. Annual Bonus for the year:</p>
              <CustomSelectField
                value={year}
                onChangeOption={(value) => setYear(value)}
                option={yearOptions.map((year) => ({
                  key: year,
                  value: year,
                }))}
                disabled={isLoading}
                isDate
              />
            </div> */}

            {/* Bonus Month Selection */}
            {/* <div
              style={{
                display: "flex",
                gap: "20px",
                width: "100%",
                alignItems: "center",
                justifyContent: "space-between",
                marginTop: ".8rem",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                <p style={{ color: "#333", whiteSpace: "nowrap" }}>3. Bonus to be paid in:</p>
                <CustomSelectField
                  value={month}
                  onChangeOption={(value) => setMonth(value)}
                  option={monthsOptions.map((month) => ({
                    key: month.key,
                    value: month.value,
                  }))}
                  disabled={isLoading}
                  isDate
                />
              </div>
            </div> */}

            {/* Average Bonus Month */}
            <div
              style={{
                display: "flex",
                gap: "10px",
                width: "100%",
                alignItems: "center",
                marginTop: ".8rem",
              }}
            >
              <p style={{ color: "#333", whiteSpace: "nowrap" }}>4. Enter Average Bonus Month:</p>
              <CustomNumberField
                value={commonBonusFactor}
                removeNumIcon={false}
                onChangeText={(text) => setCommonBonusFactor(text)}
                onBlur={() => {
                  if (parseFloat(commonBonusFactor) < 0) {
                    Notify("Average bonus month cannot be negative!", 0, {
                      autoClose: false,
                    });
                  } else {
                    setCommonBonusFactor(
                      `${(parseFloat(commonBonusFactor) || 0).toFixed(2)}`
                    );
                  }
                }}
                width="100%"
                disabled={isFinalized}
              />
            </div>
            <div
              style={{
                display: "flex",
                gap: 20,
                marginTop: ".8rem",
                width: "100%",
                alignItems: "center",
                color: "rgb(51, 51, 51)",
              }}
            >
              <p style={{ textTransform: "capitalize", whiteSpace: "nowrap" }}>
                5. Calculate Bonus for All Active employees:{" "}
              </p>
              {/* <CustomTooltip title={"Click to Start Calculating"} placement={"right"}>
                <img
                  onClick={handleCommonBonusFactorChange}
                  style={{ width: "2rem", cursor: "pointer" }}
                  src="/refresh_blue.svg"
                />
              </CustomTooltip> */}
              <CustomButton
                title="Calculate"
                onClick={handleCommonBonusFactorChange}
                styles={{
                  marginRight: "2rem",
                  width: "fit-content",
                  marginLeft: "0px",
                  whiteSpace: "nowrap",

                }}
                disable={status === "finalized" || status === "sent_for_approval" || status === "executed"}

              />
            </div>

            {/* Finalize Button */}

          </div>
        </div>


        <div style={{
          padding: "1.5rem",
          // border: "1px solid #e0e0e0",
          borderRadius: "0.75rem",
          // margin: '1rem 0',
          marginLeft: 'auto',
          marginRight: "1.75rem",
          backgroundColor: "#f8f9fa",
          boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
          width: "50%",
          border: '1px solid #333',
        }}>
          <h3 style={{
            marginBottom: "1rem",
            color: "#2c3e50",
            fontSize: "1.1rem",
            fontWeight: 600
          }}>Steps to process Annual Bonus Exercise</h3>

          <ol style={{
            listStyle: "decimal",
            paddingLeft: "20px",
            fontFamily: "system-ui, -apple-system, sans-serif",
            lineHeight: "1.8",
            color: "#4a5568",
            fontSize: "0.95rem",
            margin: 0
          }}>
            <li>
              Wait for TellBoss's request to prepare the annual bonus exercise on the Number ( usually 1 month )
              of the month given by the Boss
            </li>
            <li>
              Admin prepares the result - by click To Calculate Annual Bonus

            </li>
            <li>When ready, admin clicks here to send the result to the TellBoss app</li>
            <li>Boss reviews and makes changes, then sends revised figures to Admin</li>
            <li>Admin changes the amounts accordingly and sends them to TellBoss for final approval</li>
            <li>Admin receives final approval from Boss via the TellBoss app</li>
            <li>Admin changes the annual bonus amounts accordingly, click the create annual Bonus for every employee, and sends to the employees and send to the employee payslips. on the month Bonus is to be paid.</li>
          </ol>
        </div>

      </div>

      {/* <div
        style={{
          display: "flex",
          gap: 20,
          width: "70%",
          alignItems: "center",
        }}
      ></div> */}

      {/* For total table */}
      <table
        style={{ width: "100%", marginTop: "1rem" }}
        className="company-table"
      >
        <thead className="company-table-head" style={{ textAlign: "right" }}>
          <tr>
            <th style={{ width: "10%", textAlign: "left" }}>Total Employee</th>
            <th style={{ width: "12%", textAlign: "right" }}>Total Salary</th>
            <th style={{ width: "10%", textAlign: "right" }}>Avg Bonus Month</th>
            <th style={{ width: "10%", textAlign: "right" }}>EE CPF</th>
            <th style={{ width: "10%", textAlign: "right" }}>Co CPF</th>
            <th style={{ width: "10%", textAlign: "right" }}>Total CPF</th>
            <th style={{ width: "8%", textAlign: "right" }}>SDL</th>
            {/* <th style={{ width: "10%", textAlign: "right" }}>Bank to Pay</th>
            <th style={{ width: "10%", textAlign: "right" }}>To Pay CPF</th> */}
            <th style={{ width: "10%", textAlign: "right" }}>Bonus To Pay</th>
            <th style={{ width: "10%", textAlign: "right" }}>Bonus CPF</th>
            <th style={{ width: "10%", textAlign: "right" }}>Total Bonus</th>
            <th style={{ width: "10%", textAlign: "left" }}>{""}</th>
          </tr>
        </thead>
        <tr>
          <td style={{ width: "10%", textAlign: "left" }}>
            {employeeData?.length}
          </td>
          <td style={{ width: "12%", textAlign: "right" }}>
            {Utils.getCommanSepartedNumericStringWithDollar(totalValues?.totalSalary || 0)}
          </td>
          <td style={{ width: "10%", textAlign: "right" }}>
            {(totalValues?.averageBonusMonth || 0.00).toFixed(2)}
          </td>
          <td style={{ width: "10%", textAlign: "right" }}>
            {Utils.getCommanSepartedNumericStringWithDollar(totalValues?.totalCpfEmployee || 0)}
          </td>
          <td style={{ width: "10%", textAlign: "right" }}>
            {Utils.getCommanSepartedNumericStringWithDollar(totalValues?.totalCpfEmployer || 0)}
          </td>
          <td style={{ width: "10%", textAlign: "right" }}>
            {Utils.getCommanSepartedNumericStringWithDollar(totalValues?.totalCpfTotal || 0)}
          </td>
          <td style={{ width: "8%", textAlign: "right" }}>
            {Utils.getCommanSepartedNumericStringWithDollar(totalValues?.totalSdl || 0)}
          </td>
          {/* <td style={{ width: "10%", textAlign: "right" }}>
            {Utils.getCommanSepartedNumericStringWithDollar((totalValues?.totalBonusAmount || 0) - (totalValues?.totalCpfEmployee || 0))}
            </td>
            <td style={{ width: "10%", textAlign: "right" }}>
            {Utils.getCommanSepartedNumericStringWithDollar((totalValues?.totalCpfTotal || 0) + (totalValues?.totalSdl || 0))}
            </td> */}
          <td style={{ width: "10%", textAlign: "right" }}>
            {Utils.getCommanSepartedNumericStringWithDollar(totalValues?.totalBonusAmount || 0)}
          </td>
          <td style={{ width: "10%", textAlign: "right" }}>
            {Utils.getCommanSepartedNumericStringWithDollar(Math.floor((Math.round(totalValues?.totalCpfEmployer * 100) / 100) + (Math.round(totalValues?.totalSdl * 100) / 100)))}
          </td>
          <td style={{ width: "10%", textAlign: "right" }}>
            {Utils.getCommanSepartedNumericStringWithDollar(Math.floor((Math.round(totalValues?.totalCpfEmployer * 100) / 100) + (Math.round(totalValues?.totalSdl * 100) / 100)) + (Math.round(totalValues?.totalBonusAmount * 100) / 100))}
          </td>
          <td style={{ width: "10%", textAlign: "right" }}>
            {""}
          </td>
        </tr>
      </table>

      {isLoading ? (
        <LoaderContainer>
          <Loader />
        </LoaderContainer>
      ) : (
        <>
          <section id="report-table" style={{ marginTop: 20 }}>
            <>
              <div style={{ width: "100%" }}>
                <TableFilterHeader
                  name="Employees"
                  pageInfo={pageInfo}
                  setPageInfo={setPageInfo}
                  handlePageValueChange={(val) => handlePageValueChange(val)}
                />

                <div className="table">
                  <table className="company-table">
                    <thead className="company-table-head">
                      <tr>
                        <th style={{ width: "14%", textAlign: "left" }}>Employee Name</th>
                        <th style={{ width: "6%", textAlign: "left" }}>Hourly</th>
                        <th style={{ width: "9%", textAlign: "left" }}>Date Joined</th>
                        <th style={{ width: "9%", textAlign: "left" }}>Resigned Date</th>
                        <th style={{ width: "6%", textAlign: "left" }}>Employee ID</th>
                        <th style={{ width: "9%", textAlign: "right" }}>Basic Salary</th>
                        <th style={{ width: "9%", textAlign: "right" }}>Bonus Amount</th>
                        <th style={{ width: "7%", textAlign: "right" }}>EE CPF</th>
                        <th style={{ width: "7%", textAlign: "right" }}>Co CPF</th>
                        <th style={{ width: "7%", textAlign: "right" }}>Total CPF</th>
                        <th style={{ width: "6%", textAlign: "right" }}>SDL</th>
                        <th style={{ width: "8%", textAlign: "right" }}>
                          No. of Bonus Months
                        </th>
                        {!isFinalized && <th style={{ textAlign: "center", width: "13%" }}>
                          Action
                        </th>}
                      </tr>
                    </thead>
                    <tbody>
                      {filteredEmployeeData?.length > 0 ? (
                          filteredEmployeeData?.map((item, index) => {
                          if (item && item.archived === true) return 
                          else {
                            return <AnnualBonusRow
                              key={item?.employee}
                              data={item}
                              onDelete={handleDelete}
                              onUpdate={handleRowUpdate}
                              isEdit={isEdit}
                              isFinalized={isFinalized}
                            />
                            }
                          })
                      ) : (
                        <p style={{ textAlign: "center", margin: "2rem" }}>
                          No records found
                        </p>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          </section>
        </>
      )}
      <div style={{
        textAlign: "right",
        display: "flex",
        justifyContent: "space-between"
      }}>
        <div>

        </div>
        <div style={{
          display: "flex",
          flexDirection: "row"
        }}>
          {/* {(!isFinalized && isEdit) && (
            <CustomButton
              title={"5. Proceed to Save Draft"}
              onClick={() => setOpenSecond(true)}
              styles={{
                marginRight: "2rem",
                width: "fit-content",
                marginLeft: "0px",
                marginTop: "16px",
                whiteSpace: "nowrap",

              }}
            />
          )} */}
          {(!isFinalized && isEdit) && (
            <CustomButton
              title={"6. Proceed to Save Draft"}
              onClick={() => setOpenSecond(true)}
              styles={{
                marginRight: "2rem",
                width: "fit-content",
                marginLeft: "0px",
                marginTop: "16px",
                whiteSpace: "nowrap",
                cursor: (moment(effectiveDate).isBefore(moment(currentPayrunDate).format("YYYY-MM-DD")) || !workedTill || !effectiveDate) ? "not-allowed": "pointer"
              }}
              disable={moment(effectiveDate).isBefore(moment(currentPayrunDate).format("YYYY-MM-DD")) || !workedTill || !effectiveDate}
            />
          )}
          {!isFinalized && (
            <CustomButton
              title={isEdit ? "7. Ready to send for approval?" : "6. Ready to save Annual Bonus calculations to draft?"}
              onClick={() => setOpen(true)}
              styles={{
                marginRight: "2rem",
                backgroundColor: `${isEdit ? "#2E7D32" : ""}`,
                border: `${isEdit ? "#2E7D32" : ""}`,
                color: `${isEdit ? "#fff" : ""}`,
                width: "fit-content",
                marginLeft: "0px",
                marginTop: "1rem",
                whiteSpace: "nowrap",
                cursor: (moment(effectiveDate).isBefore(moment(currentPayrunDate).format("YYYY-MM-DD")) || !workedTill || !effectiveDate) ? "not-allowed": "pointer"
              }}
              disable={moment(effectiveDate).isBefore(moment(currentPayrunDate).format("YYYY-MM-DD")) || !workedTill || !effectiveDate}
            />
          )}

          {(isFinalized && status == "sent_for_approval") && (
            <CustomButton
              title="8. Boss Approval Received?"
              onClick={() => {
                if (moment(effectiveDate).isBefore(moment(currentPayrunDate).format("YYYY-MM-DD"))) {
                  setOpenWarn(true);
                } else {
                  setOpenConfirm(true);
                }
              }}
              styles={{
                marginRight: "2rem",
                backgroundColor: '#2E7D32',
                border: "#2E7D32",
                color: '#FFFFFF',
                width: "fit-content",
                marginLeft: "0px",
                marginTop: "16px",
                whiteSpace: "nowrap",

              }}
            />
          )}
          {(isFinalized && status === "sent_for_approval") && (
            <CustomButton
              title="9. Unapprove Annual Bonus?"
              onClick={() => setOpenUnapprove(true)}
              styles={{
                marginRight: "2rem",
                width: "fit-content",
                backgroundColor: "#F57C00",
                border: "#F57C00",
                color: '#FFFFFF',
                marginLeft: "0px",
                marginTop: "16px",
                whiteSpace: "nowrap",

              }}
            />
          )}

          {(isFinalized && status == "finalized") && (
            <CustomButton
              title="7. Execute Annual Bonus?"
              onClick={() => setOpenExecute(true)}
              styles={{
                marginRight: "2rem",
                width: "fit-content",
                backgroundColor: '#216ba5',
                color: '#FFFFFF',
                border: "#216ba5",
                marginLeft: "0px",
                marginTop: "16px",
                whiteSpace: "nowrap",

              }}
            />
          )}

        </div>
      </div>

      <CommonModal
        handleClose={() => setOpen(false)}
        open={open}
        // loading={loading}
        updateData={() => isEdit ? handleSave(false, true) : handleSave(true, true)}
        body={isEdit ? "Proceed with confirmation before sending Annual Bonus to Tellboss Payroll." : "When you click “Save Draft”, the system will save Annual Bonus as draft for later confirmation."}
        heading={isEdit ? "Ready to send for approval?" : "Ready to save Annual Bonus calculations to draft?"}
        conformButtonText={isEdit ? "Proceed for approval" : "Proceed to Save Draft"}
        cancelButtonText={isEdit ? "No - Stop" : "Cancel Stop"}
        onCancel={() => isEdit ? setOpen(false) : setOpen(false)}  //called on confirm

      />
      <CommonModal
        handleClose={() => setOpenSecond(false)}
        open={openSecond}
        updateData={() => handleSave(true, true)}
        body={"When you click “Save Draft”, the system will save Annual Bonus as draft for later confirmation."}
        heading={"Ready to save Annual Bonus calculations to draft?"}
        conformButtonText={"Proceed to Save Draft"}
        cancelButtonText={"Cancel Stop"}
        onCancel={() => setOpenSecond(false)}

      />
      <CommonModal
        handleClose={() => setOpenConfirm(false)}
        open={openConfirm}
        updateData={() => handleApprove(locationData?.id, "approve")}
        body={`Proceed to confirm Draft Annual Bonus as Final and send to payslips in payroll?`}
        heading={"Ready to confirm Draft Annual Bonus?"}
        conformButtonText={"Proceed to confirm"}
        cancelButtonText={"No - Stop"}
        onCancel={() => setOpenConfirm(false)}

      />
      <CommonModal
        handleClose={() => setOpenUnapprove(false)}
        open={openUnapprove}
        updateData={() => handleApprove(locationData?.id, "unapprove")}
        body={`Proceed to confirm Draft Annual Bonus Unapprove the bonus?`}
        heading={"Ready to confirm Draft Annual Bonus UnApprove?"}
        conformButtonText={"Continue"}
        cancelButtonText={"Cancel"}
        onCancel={() => setOpenConfirm(false)}

      />
      <CommonModal
        handleClose={() => setOpenExecute(false)}
        open={openExecute}
        updateData={() => handleExecute(locationData?.id)}
        body={`The execution date is ${moment(effectiveDate).format("DD-MM-YYYY")}. Do you really want to proceed with today's date?`}
        heading={"Ready to excute Annual Bonus?"}
        conformButtonText={"Continue"}
        cancelButtonText={"Cancel"}
        onCancel={() => setOpenConfirm(false)}

      />
      
      <WarningModal
        isOpen={duplicateYearModal}
        onClose={() => setDuplicateYearModal(false)}
        title={duplicateYearWarningTitle}
        message={duplicateYearWarningMessage}
        actionText="Ok"
        onAction={()=>setDuplicateYearModal(false)}
      />
      
      <WarningModal
        isOpen={openWarn}
        onClose={() => setOpenWarn(false)}
        title="Action Required"
        message="Cannot approve. The Payrun Date is in the past. Please unapprove and update the Payrun Date before proceeding."
        actionText="Yes, Proceed"
        onAction={() => handleApprove(locationData?.id, "unapprove")}
      />

    </div>
  );
};

export default AnnualBonus;


const getYearRange = (year: string) => {
  const startYear = parseInt(year);
  const yearsRange = [startYear];

  for (let i = 1; i < 10; i++) {
    yearsRange.push(startYear + i);
  }
  return yearsRange;
};

const employeeDataExample = [
  {
    employee: 152,
    employee_name: "ANG POH HONG",
    date_joined: "2023-12-26",
    resigned_date: null,
    basic_salary: "5,300.00",
    salary_type: null,
    bonus_amount: null,
    no_of_bonus_months: null,
    cpf_calculator_data: [
      {
        id: 412,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 0,
        age_max: 55,
        salary_min: 0,
        salary_max: 50,
        total_cpf: "0",
        employee_cpf: "0",
      },
      {
        id: 418,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 0,
        age_max: 55,
        salary_min: 50,
        salary_max: 500,
        total_cpf: "17% (TW)",
        employee_cpf: "0",
      },
      {
        id: 419,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 0,
        age_max: 55,
        salary_min: 750,
        salary_max: 500000,
        total_cpf: "37% (OW) + 37% (AW), $2960",
        employee_cpf: "20% (OW) + 20% (AW), $1600",
      },
      {
        id: 405,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 0,
        age_max: 55,
        salary_min: 500,
        salary_max: 750,
        total_cpf: "17% (TW) + 0.6* (TW - $500)",
        employee_cpf: "0.6* (TW - $500)",
      },
    ],
    sdl_data: [
      {
        id: 2,
        min_amount: 800.01,
        max_amount: 1000000,
        percentage: 0.25,
        max_sdl: 11.25,
        min_sdl: 2,
      },
      {
        id: 1,
        min_amount: 0,
        max_amount: 800,
        percentage: 0.25,
        max_sdl: 2,
        min_sdl: 2,
      },
    ],
  },
  {
    employee: 245,
    employee_name: "CHONG CHAU LENG",
    date_joined: "2018-07-03",
    resigned_date: null,
    basic_salary: "6,800.00",
    salary_type: null,
    bonus_amount: null,
    no_of_bonus_months: null,
    cpf_calculator_data: [
      {
        id: 412,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 0,
        age_max: 55,
        salary_min: 0,
        salary_max: 50,
        total_cpf: "0",
        employee_cpf: "0",
      },
      {
        id: 418,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 0,
        age_max: 55,
        salary_min: 50,
        salary_max: 500,
        total_cpf: "17% (TW)",
        employee_cpf: "0",
      },
      {
        id: 419,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 0,
        age_max: 55,
        salary_min: 750,
        salary_max: 500000,
        total_cpf: "37% (OW) + 37% (AW), $2960",
        employee_cpf: "20% (OW) + 20% (AW), $1600",
      },
      {
        id: 405,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 0,
        age_max: 55,
        salary_min: 500,
        salary_max: 750,
        total_cpf: "17% (TW) + 0.6* (TW - $500)",
        employee_cpf: "0.6* (TW - $500)",
      },
    ],
    sdl_data: [
      {
        id: 2,
        min_amount: 800.01,
        max_amount: 1000000,
        percentage: 0.25,
        max_sdl: 11.25,
        min_sdl: 2,
      },
      {
        id: 1,
        min_amount: 0,
        max_amount: 800,
        percentage: 0.25,
        max_sdl: 2,
        min_sdl: 2,
      },
    ],
  },
  {
    employee: 422,
    employee_name: "CHUAH WEI LU",
    date_joined: "2025-06-01",
    resigned_date: null,
    basic_salary: "3,650.00",
    salary_type: null,
    bonus_amount: null,
    no_of_bonus_months: null,
    cpf_calculator_data: [
      {
        id: 412,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 0,
        age_max: 55,
        salary_min: 0,
        salary_max: 50,
        total_cpf: "0",
        employee_cpf: "0",
      },
      {
        id: 418,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 0,
        age_max: 55,
        salary_min: 50,
        salary_max: 500,
        total_cpf: "17% (TW)",
        employee_cpf: "0",
      },
      {
        id: 419,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 0,
        age_max: 55,
        salary_min: 750,
        salary_max: 500000,
        total_cpf: "37% (OW) + 37% (AW), $2960",
        employee_cpf: "20% (OW) + 20% (AW), $1600",
      },
      {
        id: 405,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 0,
        age_max: 55,
        salary_min: 500,
        salary_max: 750,
        total_cpf: "17% (TW) + 0.6* (TW - $500)",
        employee_cpf: "0.6* (TW - $500)",
      },
    ],
    sdl_data: [
      {
        id: 2,
        min_amount: 800.01,
        max_amount: 1000000,
        percentage: 0.25,
        max_sdl: 11.25,
        min_sdl: 2,
      },
      {
        id: 1,
        min_amount: 0,
        max_amount: 800,
        percentage: 0.25,
        max_sdl: 2,
        min_sdl: 2,
      },
    ],
  },
  {
    employee: 265,
    employee_name: "GUI LAY BAY",
    date_joined: "2024-05-15",
    resigned_date: null,
    basic_salary: "3,200.00",
    salary_type: null,
    bonus_amount: null,
    no_of_bonus_months: null,
    cpf_calculator_data: [
      {
        id: 407,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 60,
        age_max: 65,
        salary_min: 0,
        salary_max: 50,
        total_cpf: "0",
        employee_cpf: "0",
      },
      {
        id: 408,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 65,
        age_max: 70,
        salary_min: 0,
        salary_max: 50,
        total_cpf: "0",
        employee_cpf: "0",
      },
      {
        id: 416,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 65,
        age_max: 70,
        salary_min: 50,
        salary_max: 500,
        total_cpf: "9% (TW)",
        employee_cpf: "0",
      },
      {
        id: 414,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 60,
        age_max: 65,
        salary_min: 50,
        salary_max: 500,
        total_cpf: "12.5% (TW)",
        employee_cpf: "0",
      },
      {
        id: 417,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 65,
        age_max: 70,
        salary_min: 500,
        salary_max: 750,
        total_cpf: "9% (TW) + 0.225* (TW - $500)",
        employee_cpf: "0.225* (TW - $500)",
      },
      {
        id: 422,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 65,
        age_max: 70,
        salary_min: 750,
        salary_max: 500000,
        total_cpf: "16.5% (OW) + 16.5% (AW),  $1320",
        employee_cpf: "7.5% (OW) + 7.5% (AW), $600",
      },
      {
        id: 421,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 60,
        age_max: 65,
        salary_min: 750,
        salary_max: 50000,
        total_cpf: "23.5(OW) + 23.5% (AW), $1880",
        employee_cpf: "11.5% (OW) + 11.5% (AW),  $920",
      },
      {
        id: 415,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 60,
        age_max: 65,
        salary_min: 500,
        salary_max: 750,
        total_cpf: "12.5% (TW) + 0.345*(TW - $500)",
        employee_cpf: "0.345*(TW - $500)",
      },
    ],
    sdl_data: [
      {
        id: 2,
        min_amount: 800.01,
        max_amount: 1000000,
        percentage: 0.25,
        max_sdl: 11.25,
        min_sdl: 2,
      },
      {
        id: 1,
        min_amount: 0,
        max_amount: 800,
        percentage: 0.25,
        max_sdl: 2,
        min_sdl: 2,
      },
    ],
  },
  {
    employee: 140,
    employee_name: "HO HAO QING JARRICA",
    date_joined: "2022-12-01",
    resigned_date: null,
    basic_salary: "4,700.00",
    salary_type: null,
    bonus_amount: null,
    no_of_bonus_months: null,
    cpf_calculator_data: [
      {
        id: 412,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 0,
        age_max: 55,
        salary_min: 0,
        salary_max: 50,
        total_cpf: "0",
        employee_cpf: "0",
      },
      {
        id: 418,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 0,
        age_max: 55,
        salary_min: 50,
        salary_max: 500,
        total_cpf: "17% (TW)",
        employee_cpf: "0",
      },
      {
        id: 419,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 0,
        age_max: 55,
        salary_min: 750,
        salary_max: 500000,
        total_cpf: "37% (OW) + 37% (AW), $2960",
        employee_cpf: "20% (OW) + 20% (AW), $1600",
      },
      {
        id: 405,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 0,
        age_max: 55,
        salary_min: 500,
        salary_max: 750,
        total_cpf: "17% (TW) + 0.6* (TW - $500)",
        employee_cpf: "0.6* (TW - $500)",
      },
    ],
    sdl_data: [
      {
        id: 2,
        min_amount: 800.01,
        max_amount: 1000000,
        percentage: 0.25,
        max_sdl: 11.25,
        min_sdl: 2,
      },
      {
        id: 1,
        min_amount: 0,
        max_amount: 800,
        percentage: 0.25,
        max_sdl: 2,
        min_sdl: 2,
      },
    ],
  },
  {
    employee: 144,
    employee_name: "LEE PRISCILLA MARY",
    date_joined: "2014-01-01",
    resigned_date: null,
    basic_salary: "6,000.00",
    salary_type: null,
    bonus_amount: null,
    no_of_bonus_months: null,
    cpf_calculator_data: [
      {
        id: 409,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 70,
        age_max: 90,
        salary_min: 0,
        salary_max: 50,
        total_cpf: "0",
        employee_cpf: "0",
      },
      {
        id: 410,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 70,
        age_max: 90,
        salary_min: 50,
        salary_max: 500,
        total_cpf: "7.5% (TW)",
        employee_cpf: "0",
      },
      {
        id: 411,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 70,
        age_max: 90,
        salary_min: 500,
        salary_max: 750,
        total_cpf: "7.5% (TW) + 0.15* (TW - $500)",
        employee_cpf: "0.15* (TW - $500)",
      },
      {
        id: 423,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 70,
        age_max: 90,
        salary_min: 750,
        salary_max: 50000,
        total_cpf: "12.5% (OW) + 12.5% (AW),  $1000",
        employee_cpf: "5% (OW) + 5% (AW), $400",
      },
    ],
    sdl_data: [
      {
        id: 2,
        min_amount: 800.01,
        max_amount: 1000000,
        percentage: 0.25,
        max_sdl: 11.25,
        min_sdl: 2,
      },
      {
        id: 1,
        min_amount: 0,
        max_amount: 800,
        percentage: 0.25,
        max_sdl: 2,
        min_sdl: 2,
      },
    ],
  },
  {
    employee: 266,
    employee_name: "NURUL AIN RASYIDAH BINTI SANAF",
    date_joined: "2024-05-15",
    resigned_date: null,
    basic_salary: "2,800.00",
    salary_type: null,
    bonus_amount: null,
    no_of_bonus_months: null,
    cpf_calculator_data: [
      {
        id: 445,
        group_code: "Code4",
        group_name: "1st yr Graduated contribution rates (G/G)",
        age_min: 0,
        age_max: 55,
        salary_min: 50,
        salary_max: 500,
        total_cpf: "4% (TW)",
        employee_cpf: "0",
      },
      {
        id: 446,
        group_code: "Code4",
        group_name: "1st yr Graduated contribution rates (G/G)",
        age_min: 0,
        age_max: 55,
        salary_min: 500,
        salary_max: 750,
        total_cpf: "4% (TW) + 0.15* (TW - $500)",
        employee_cpf: "0.15* (TW - $500)",
      },
      {
        id: 456,
        group_code: "Code4",
        group_name: "1st yr Graduated contribution rates (G/G)",
        age_min: 0,
        age_max: 55,
        salary_min: 0,
        salary_max: 50,
        total_cpf: "0",
        employee_cpf: "0",
      },
      {
        id: 444,
        group_code: "Code4",
        group_name: "1st yr Graduated contribution rates (G/G)",
        age_min: 0,
        age_max: 55,
        salary_min: 750,
        salary_max: 500000,
        total_cpf: "9% (OW) + 9% (AW), $720",
        employee_cpf: "5% (OW) + 5% (AW), $400",
      },
    ],
    sdl_data: [
      {
        id: 2,
        min_amount: 800.01,
        max_amount: 1000000,
        percentage: 0.25,
        max_sdl: 11.25,
        min_sdl: 2,
      },
      {
        id: 1,
        min_amount: 0,
        max_amount: 800,
        percentage: 0.25,
        max_sdl: 2,
        min_sdl: 2,
      },
    ],
  },
  {
    employee: 303,
    employee_name: "SIA JIEA JING DESMOND",
    date_joined: "2024-11-01",
    resigned_date: null,
    basic_salary: "3,300.00",
    salary_type: null,
    bonus_amount: null,
    no_of_bonus_months: null,
    cpf_calculator_data: [
      {
        id: 412,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 0,
        age_max: 55,
        salary_min: 0,
        salary_max: 50,
        total_cpf: "0",
        employee_cpf: "0",
      },
      {
        id: 418,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 0,
        age_max: 55,
        salary_min: 50,
        salary_max: 500,
        total_cpf: "17% (TW)",
        employee_cpf: "0",
      },
      {
        id: 419,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 0,
        age_max: 55,
        salary_min: 750,
        salary_max: 500000,
        total_cpf: "37% (OW) + 37% (AW), $2960",
        employee_cpf: "20% (OW) + 20% (AW), $1600",
      },
      {
        id: 405,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 0,
        age_max: 55,
        salary_min: 500,
        salary_max: 750,
        total_cpf: "17% (TW) + 0.6* (TW - $500)",
        employee_cpf: "0.6* (TW - $500)",
      },
    ],
    sdl_data: [
      {
        id: 2,
        min_amount: 800.01,
        max_amount: 1000000,
        percentage: 0.25,
        max_sdl: 11.25,
        min_sdl: 2,
      },
      {
        id: 1,
        min_amount: 0,
        max_amount: 800,
        percentage: 0.25,
        max_sdl: 2,
        min_sdl: 2,
      },
    ],
  },
  {
    employee: 258,
    employee_name: "SIM MONG CHAI",
    date_joined: "2016-01-01",
    resigned_date: null,
    basic_salary: "5,000.00",
    salary_type: null,
    bonus_amount: null,
    no_of_bonus_months: null,
    cpf_calculator_data: [
      {
        id: 409,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 70,
        age_max: 90,
        salary_min: 0,
        salary_max: 50,
        total_cpf: "0",
        employee_cpf: "0",
      },
      {
        id: 410,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 70,
        age_max: 90,
        salary_min: 50,
        salary_max: 500,
        total_cpf: "7.5% (TW)",
        employee_cpf: "0",
      },
      {
        id: 411,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 70,
        age_max: 90,
        salary_min: 500,
        salary_max: 750,
        total_cpf: "7.5% (TW) + 0.15* (TW - $500)",
        employee_cpf: "0.15* (TW - $500)",
      },
      {
        id: 423,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 70,
        age_max: 90,
        salary_min: 750,
        salary_max: 50000,
        total_cpf: "12.5% (OW) + 12.5% (AW),  $1000",
        employee_cpf: "5% (OW) + 5% (AW), $400",
      },
    ],
    sdl_data: [
      {
        id: 2,
        min_amount: 800.01,
        max_amount: 1000000,
        percentage: 0.25,
        max_sdl: 11.25,
        min_sdl: 2,
      },
      {
        id: 1,
        min_amount: 0,
        max_amount: 800,
        percentage: 0.25,
        max_sdl: 2,
        min_sdl: 2,
      },
    ],
  },
  {
    employee: 146,
    employee_name: "SIM SIANG HWEE IVAN",
    date_joined: "2020-09-01",
    resigned_date: null,
    basic_salary: "8,200.00",
    salary_type: null,
    bonus_amount: null,
    no_of_bonus_months: null,
    cpf_calculator_data: [
      {
        id: 412,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 0,
        age_max: 55,
        salary_min: 0,
        salary_max: 50,
        total_cpf: "0",
        employee_cpf: "0",
      },
      {
        id: 418,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 0,
        age_max: 55,
        salary_min: 50,
        salary_max: 500,
        total_cpf: "17% (TW)",
        employee_cpf: "0",
      },
      {
        id: 419,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 0,
        age_max: 55,
        salary_min: 750,
        salary_max: 500000,
        total_cpf: "37% (OW) + 37% (AW), $2960",
        employee_cpf: "20% (OW) + 20% (AW), $1600",
      },
      {
        id: 405,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 0,
        age_max: 55,
        salary_min: 500,
        salary_max: 750,
        total_cpf: "17% (TW) + 0.6* (TW - $500)",
        employee_cpf: "0.6* (TW - $500)",
      },
    ],
    sdl_data: [
      {
        id: 2,
        min_amount: 800.01,
        max_amount: 1000000,
        percentage: 0.25,
        max_sdl: 11.25,
        min_sdl: 2,
      },
      {
        id: 1,
        min_amount: 0,
        max_amount: 800,
        percentage: 0.25,
        max_sdl: 2,
        min_sdl: 2,
      },
    ],
  },
  {
    employee: 145,
    employee_name: "SIM SOO GEK SHEILA",
    date_joined: "2014-01-01",
    resigned_date: null,
    basic_salary: "3,000.00",
    salary_type: null,
    bonus_amount: null,
    no_of_bonus_months: null,
    cpf_calculator_data: [
      {
        id: 412,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 0,
        age_max: 55,
        salary_min: 0,
        salary_max: 50,
        total_cpf: "0",
        employee_cpf: "0",
      },
      {
        id: 418,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 0,
        age_max: 55,
        salary_min: 50,
        salary_max: 500,
        total_cpf: "17% (TW)",
        employee_cpf: "0",
      },
      {
        id: 419,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 0,
        age_max: 55,
        salary_min: 750,
        salary_max: 500000,
        total_cpf: "37% (OW) + 37% (AW), $2960",
        employee_cpf: "20% (OW) + 20% (AW), $1600",
      },
      {
        id: 405,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 0,
        age_max: 55,
        salary_min: 500,
        salary_max: 750,
        total_cpf: "17% (TW) + 0.6* (TW - $500)",
        employee_cpf: "0.6* (TW - $500)",
      },
    ],
    sdl_data: [
      {
        id: 2,
        min_amount: 800.01,
        max_amount: 1000000,
        percentage: 0.25,
        max_sdl: 11.25,
        min_sdl: 2,
      },
      {
        id: 1,
        min_amount: 0,
        max_amount: 800,
        percentage: 0.25,
        max_sdl: 2,
        min_sdl: 2,
      },
    ],
  },
  {
    employee: 244,
    employee_name: "WONG MAY LUN CYNDI",
    date_joined: "2016-08-22",
    resigned_date: null,
    basic_salary: "4,800.00",
    salary_type: null,
    bonus_amount: null,
    no_of_bonus_months: null,
    cpf_calculator_data: [
      {
        id: 407,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 60,
        age_max: 65,
        salary_min: 0,
        salary_max: 50,
        total_cpf: "0",
        employee_cpf: "0",
      },
      {
        id: 414,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 60,
        age_max: 65,
        salary_min: 50,
        salary_max: 500,
        total_cpf: "12.5% (TW)",
        employee_cpf: "0",
      },
      {
        id: 421,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 60,
        age_max: 65,
        salary_min: 750,
        salary_max: 50000,
        total_cpf: "23.5(OW) + 23.5% (AW), $1880",
        employee_cpf: "11.5% (OW) + 11.5% (AW),  $920",
      },
      {
        id: 415,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 60,
        age_max: 65,
        salary_min: 500,
        salary_max: 750,
        total_cpf: "12.5% (TW) + 0.345*(TW - $500)",
        employee_cpf: "0.345*(TW - $500)",
      },
    ],
    sdl_data: [
      {
        id: 2,
        min_amount: 800.01,
        max_amount: 1000000,
        percentage: 0.25,
        max_sdl: 11.25,
        min_sdl: 2,
      },
      {
        id: 1,
        min_amount: 0,
        max_amount: 800,
        percentage: 0.25,
        max_sdl: 2,
        min_sdl: 2,
      },
    ],
  },
  {
    employee: 147,
    employee_name: "ZHANG JINGJIANG",
    date_joined: "2011-09-20",
    resigned_date: null,
    basic_salary: "8,800.00",
    salary_type: null,
    bonus_amount: null,
    no_of_bonus_months: null,
    cpf_calculator_data: [
      {
        id: 412,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 0,
        age_max: 55,
        salary_min: 0,
        salary_max: 50,
        total_cpf: "0",
        employee_cpf: "0",
      },
      {
        id: 418,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 0,
        age_max: 55,
        salary_min: 50,
        salary_max: 500,
        total_cpf: "17% (TW)",
        employee_cpf: "0",
      },
      {
        id: 419,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 0,
        age_max: 55,
        salary_min: 750,
        salary_max: 500000,
        total_cpf: "37% (OW) + 37% (AW), $2960",
        employee_cpf: "20% (OW) + 20% (AW), $1600",
      },
      {
        id: 405,
        group_code: "Code5",
        group_name: "3rd Year and Onwards",
        age_min: 0,
        age_max: 55,
        salary_min: 500,
        salary_max: 750,
        total_cpf: "17% (TW) + 0.6* (TW - $500)",
        employee_cpf: "0.6* (TW - $500)",
      },
    ],
    sdl_data: [
      {
        id: 2,
        min_amount: 800.01,
        max_amount: 1000000,
        percentage: 0.25,
        max_sdl: 11.25,
        min_sdl: 2,
      },
      {
        id: 1,
        min_amount: 0,
        max_amount: 800,
        percentage: 0.25,
        max_sdl: 2,
        min_sdl: 2,
      },
    ],
  },
];
